import { useInstance } from '@meraki-internal/react-dependency-injection';
import { OrganizationsState } from './OrganizationsState';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { useSubscription } from '@meraki-internal/state';
import { NavigationItem } from '../navigation/NavigationItem';
import { NavigationItemList } from '../navigation/NavigationItemList';

export const OrganizationsNavigationMenu: React.FC<{closeMenuHandler: () => void}> = ({ closeMenuHandler }) => {
    const history = useInstance(HistoryViewModel);

    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    const activeOrgId = orgState.getMostRecentOrganization()?.orgId;

    const closeAndExecute = (handler: () => void) => {
        closeMenuHandler();
        setTimeout(() => {
            handler();
        }, 350);
    };

    const onClick = (path: string) => {
        closeAndExecute(() => {
            // why not href? if the page had a query param, it is causing a page load
            // eg downstream of using visitWithPageLoad (which adds a query param to the url)
            history.push(path);
        });
    };

    return (
        <NavigationItemList>
            {orgState.getNonClientOrganizations().map((o, idx) => {
                return (
                    <NavigationItem
                        key={o.orgId}
                        label={o.name}
                        data-type={`nav-organization`}
                        data-id={o.orgId}
                        onClick={() => onClick(`/org/${o.orgId}`)}
                        isSelected={o.orgId === activeOrgId}
                    />
                );
            })}
        </NavigationItemList>
    );
};
